import React, { createContext, useContext } from 'react'

export const FEED_TAB_ID = 'feed'
export const PROGRESS_TAB_ID = 'progress'
export const MEDICAL_RECORD_TAB_ID = 'medicalRecord'
export const CARE_PLAN_TAB_ID = 'carePlan'

export type TabNavigation = { openTab: (tabId: string) => void; hasTab: (tabId: string) => boolean }

const NO_NAVIGATION: TabNavigation = { openTab: () => undefined, hasTab: () => false }

const TabNavigationContext = createContext<TabNavigation>(NO_NAVIGATION)

// Lets a panel send the coach to another workspace tab without taking props (panels take none).
export const TabNavigationProvider = ({ value, children }: { value: TabNavigation; children: React.ReactNode }) => (
  <TabNavigationContext.Provider value={value}>{children}</TabNavigationContext.Provider>
)

export const useTabNavigation = (): TabNavigation => useContext(TabNavigationContext)
